module.exports = __webpack_public_path__ + "static/media/cdb2.6d364a64.png";